// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as App_Api$DvmAdminFrontendFr from "../../common/App_Api.bs.js";
import * as App_Modal$DvmAdminFrontendFr from "../../common/components/App_Modal.bs.js";
import * as App_Button$DvmAdminFrontendFr from "../../common/components/button/App_Button.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../common/utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../context/user/User_Context.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../common/components/App_LabeledText.bs.js";
import * as Messages_Button$DvmAdminFrontendFr from "../../intl/messages/Messages_Button.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../common/types/App_Types_Result.bs.js";
import * as Model_Version_Api$DvmAdminFrontendFr from "./Model_Version_Api.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../common/components/App_OverlaySpinner.bs.js";
import * as Messages_ModelVersion$DvmAdminFrontendFr from "../../intl/messages/modelVersion/Messages_ModelVersion.bs.js";
import * as App_AutocompleteFormInput$DvmAdminFrontendFr from "../../common/components/input/App_AutocompleteFormInput.bs.js";

function getLabeledText(text, label) {
  return React.createElement(Core.Grid, {
              children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                    label: label,
                    children: text,
                    variantChild: "h5"
                  }),
              item: true
            });
}

function ModelVersion_Motorization_Modal(Props) {
  var onClose = Props.onClose;
  var row = Props.row;
  var onOk = Props.onOk;
  var intl = ReactIntl.useIntl();
  var alert = ReactAlert.useAlert();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResult = match$2[1];
  var result = match$2[0];
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setMotorizations = match$3[1];
  var motorizations = match$3[0];
  var match$4 = React.useState(function () {
        return Belt_Option.getWithDefault(row.identificationEngineType, "");
      });
  var setMotorizationSelect = match$4[1];
  var motorizationSelect = match$4[0];
  React.useEffect((function () {
          App_Api$DvmAdminFrontendFr.fetchMotorisations(setMotorizations, userManager, selectedRole);
        }), []);
  React.useEffect((function () {
          if (typeof result === "number") {
            result === /* NotStarted */0;
          } else if (result.TAG === /* Ok */0) {
            Utils_Alert$DvmAdminFrontendFr.success(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {}));
            Curry._1(onOk, undefined);
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: result._0
                      }
                    }));
          }
        }), [result]);
  return React.createElement(App_Modal$DvmAdminFrontendFr.make, {
              open: true,
              onClose: onClose,
              title: intl.formatMessage(Messages_Common$DvmAdminFrontendFr.modifyRow),
              minWidth: "500px",
              children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                    show: App_Types_Result$DvmAdminFrontendFr.isPending(result) || App_Types_Result$DvmAdminFrontendFr.isPending(motorizations),
                    children: React.createElement(Core.Grid, {
                          children: null,
                          container: true,
                          direction: "column",
                          spacing: 2
                        }, React.createElement(Core.Grid, {
                              children: React.createElement(React.Fragment, undefined, React.createElement(Core.Grid, {
                                        children: null,
                                        container: true,
                                        item: true,
                                        spacing: 3
                                      }, getLabeledText(row.model, Messages_Common$DvmAdminFrontendFr.model), getLabeledText(row.modelLabel, Messages_ModelVersion$DvmAdminFrontendFr.labelModel), getLabeledText(Belt_Option.getWithDefault(row.versionVehiclePhase, "-"), Messages_Common$DvmAdminFrontendFr.phase)), React.createElement(Core.Grid, {
                                        children: null,
                                        container: true,
                                        item: true,
                                        spacing: 3
                                      }, getLabeledText(row.version, Messages_Common$DvmAdminFrontendFr.version), getLabeledText(row.versionLabel, Messages_ModelVersion$DvmAdminFrontendFr.labelVersion))),
                              container: true,
                              direction: "column",
                              item: true,
                              spacing: 2
                            }), React.createElement(Core.Grid, {
                              children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, {
                                    label: Messages_ModelVersion$DvmAdminFrontendFr.motorization,
                                    value: {
                                      TAG: /* Single */0,
                                      _0: {
                                        value: motorizationSelect,
                                        onChange: (function (val) {
                                            Curry._1(setMotorizationSelect, (function (param) {
                                                    return val;
                                                  }));
                                          })
                                      }
                                    },
                                    options: {
                                      TAG: /* Unlabeled */0,
                                      _0: Belt_List.sort(App_Types_Result$DvmAdminFrontendFr.getWithDefault(motorizations, /* [] */0), Caml.string_compare)
                                    }
                                  }),
                              item: true
                            }), React.createElement(Core.Grid, {
                              children: null,
                              container: true,
                              justifyContent: "space-between"
                            }, React.createElement(Core.Grid, {
                                  children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                        onClick: (function (param) {
                                            Curry._1(onClose, undefined);
                                          }),
                                        label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.cancel),
                                        color: "primaryBorder",
                                        size: "medium"
                                      }),
                                  item: true
                                }), React.createElement(Core.Grid, {
                                  children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                        onClick: (function (param) {
                                            Model_Version_Api$DvmAdminFrontendFr.editMotorization(motorizationSelect, row.modelVersionId, userManager, setResult, selectedRole);
                                          }),
                                        label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.confirm),
                                        size: "medium"
                                      }),
                                  item: true
                                })))
                  })
            });
}

var Types;

var Api;

var make = ModelVersion_Motorization_Modal;

export {
  Types ,
  Api ,
  getLabeledText ,
  make ,
}
/* react Not a pure module */
